
import React, { useEffect, useState, useRef } from "react";
import isEqual from 'lodash/isEqual';
import styles from '../LessonModal.module.css'; 
import s from "../Lesson.module.css";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { useAppTranslation } from "./TranslationContext";

export const Lesson = () => {
  const { user, handleLang } = useAuth();
  const { t } = useAppTranslation();
  const { userKursData, setUserKursData } = useAuth();
  const { kursId, id } = useParams();
  const navigate = useNavigate();
  let localUser = JSON.parse(localStorage.getItem('user'));
  // console.log("user:", localUser)
  const [dataThemes, setThemes] = useState([]);
  // const [themes, setProcessedThemes] = useState([]);
  const [lessonData, setLessonData] = useState(null);
  const [prevLesson, setPrevLesson] = useState(null);
  const [nextLesson, setNextLesson] = useState(null);

  const [loadingThemes, setLoadingThemes] = useState(true);
  const [errorThemes, setErrorThemes] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Получаем user-kurs
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const token = localStorage.getItem('token');
        // if (!token || !user?.id) return;
        const response = await fetch('https://api.rasulova-academy.uz/api/user-kurs/');
        // const res = await fetch(`https://api.rasulova-academy.uz/api/user-kurs/?user=${user.id}&kurs=${kursId}`, {
        //   headers: {
        //     'Authorization': `Token ${token}`
        //   }
        // });

        if (!response.ok) {
          throw new Error('Ошибка при загрузке данных');
        }
  
        const data = await response.json(); // 👈 получаем JSON
        console.log('Данные с сервера:', data);
        console.log(localUser)
        const foundItem = data.find(item =>
          (parseInt(item.kurs) === parseInt(kursId)) && (parseInt(item.user) === parseInt(localUser.id))
        );
        console.log(foundItem)
        setUserKursData({
          id: foundItem.id,
          mavzu: foundItem.mavzu,
        });
        console.log('Данные с:', userKursData);
      } catch (error) {
        console.error('Произошла ошибка:', error);
      }
      
    };
  
    fetchData();

  }, []);
  
  useEffect(() => {
    console.log("userKursData o'zgardi:", userKursData);
  }, [userKursData]);
  // console.log(userKursData)
  // Получаем список всех тем
  useEffect(() => {
    const fetchThemes = async () => {
      try {
        const res = await fetch(`https://api.rasulova-academy.uz/api/kurs-mavzulari/?kurs=${kursId}`);
        if (!res.ok) throw new Error("Ошибка сети");
        const data = await res.json();
        setThemes(data);
        console.log(data)
      } catch (err) {
        setErrorThemes(err.message);
      } finally {
        setLoadingThemes(false);
      }
    };
  
    fetchThemes();
  }, [kursId]);
  
  
  // console.log(dataThemes)
  
  // Обработка тем по курсу
  // Загружаем только данные текущего урока
useEffect(() => {
  const fetchLesson = async () => {
    try {
      const res = await fetch(`https://api.rasulova-academy.uz/api/kurs-mavzulari/${id}/`);
      if (!res.ok) throw new Error("Ошибка при загрузке урока");
      const data = await res.json();

      setLessonData({
        id: data.id,
        tartib: data.tartib,
        kurs_id: parseInt(kursId),
        title_uz: data.nomi_uz,
        title_ru: data.nomi_ru,
        title_en: data.nomi_en,
        videolink_uz: data.videolink_uz,
        videolink_ru: data.videolink_ru,
        videolink_en: data.videolink_en,
        text_uz: data.maruza_matn_uz,
        text_ru: data.maruza_matn_ru,
        text_en: data.maruza_matn_en,
        file_uz: data.maruza_file_uz,
        file_ru: data.maruza_file_ru,
        file_en: data.maruza_file_en,
        test_soni: data.test_soni,
        test_min: data.test_min_soni,
        test_description_uz: data.test_description_uz,
        test_description_ru: data.test_description_ru,
        test_description_en: data.test_description_en
      });
    } catch (err) {
      console.error(err);
    }
  };

  fetchLesson();
}, [id, kursId]);

  // console.log(themes)
  // Определение текущего, предыдущего и следующего урока
  // Определяем предыдущий и следующий урок, когда есть темы и урок
useEffect(() => {
  if (!dataThemes.length || !lessonData) return;
  console.log(lessonData)
  let prev = null, next = null;
  dataThemes.forEach(item => {
    if (item.tartib === lessonData.tartib - 1) prev = item;
    if (item.tartib === lessonData.tartib + 1) next = item;
  });

  setPrevLesson(prev);
  setNextLesson(next);
}, [dataThemes, lessonData]);

  console.log(userKursData)
  // Переключение уроков
  const goToPreviousLesson = () => {
    if (prevLesson) navigate(`/Lesson/${kursId}/${prevLesson.id}`);
  };

  const goToNextLesson = () => {
    if (!userKursData) return; // Защита от null
  
    const allowedIndex = userKursData.mavzu;
    if (nextLesson && nextLesson.tartib <= allowedIndex) {
      navigate(`/Lesson/${kursId}/${nextLesson.id}`);
    }
  };
  
  
  // console.log(lessonData)
  // Модальное окно
  const openModal = () => {
    setIsOpen(true);
    setTimeout(() => setIsVisible(true), 10);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    }, 400);
  };

  const onOverlayClick = (e) => {
    if (e.target === e.currentTarget) closeModal();
  };

  console.log(lessonData)
  if (!lessonData) return <div className={s.container}>Загрузка...</div>;
  console.log(lessonData)
  return (
    
    <div className={s.container}>

      {isOpen && (
        <div
          className={`${styles.lessonOverlay} ${isVisible ? styles.visible : ''}`}
          onClick={onOverlayClick}
        >
          <div className={styles.lessonModal}>
            <div className={styles.lessonModalHeader}>
              <h2>
                {t('contents')}
              </h2>
              <button className={styles.lessonCloseBtn} onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className={styles.lessonModalContent}>
              <ul>
                {/* //////////////////////////////////////////////// */}
                {/* Modal menu */}
                {dataThemes.map((item, index) => {
                  const allowedIndex = userKursData.mavzu || 0;
                  const isLocked = item.tartib > allowedIndex;
                  console.log(item.tartib)
                  return isLocked ? (
                    <li key={index} className={styles.disabledItem}>
                      {handleLang(item.nomi_uz, item.nomi_ru, item.nomi_en)}
                    </li>
                  ) : (
                    <Link to={`/Lesson/${kursId}/${item.id}`} key={index}>
                      <li>
                        {handleLang(item.nomi_uz, item.nomi_ru, item.nomi_en)}
                      </li>
                    </Link>
                  );
                })}


                {/* /////////////////////////////////////////////////// */}
              </ul>
            </div>
          </div>
        </div>
      )}
      <section className={s.lesson}>
        <div className={s.lesson__subheader}>
          
          
          <p className={s.lesson__title}>
            {handleLang(lessonData.title_uz, lessonData.title_ru, lessonData.title_en)}
          </p>

          <div className={s.lesson__subheaderRight}>
          {/* кнопка списка уроков */}
          <div className={s.lesson__subheaderImg} onClick={openModal}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                className={s.lesson__subheaderImgSvg}
            >
                <g>
                <path
                    className={s.lesson__subheaderImgPath}
                    d="M27 10H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3zm1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1zm-7.55-7.89-8-4A1 1 0 0 0 11 16v8a1 1 0 0 0 .47.85A1 1 0 0 0 12 25a1 1 0 0 0 .45-.11l8-4a1 1 0 0 0 0-1.78zM13 22.38v-4.76L17.76 20zM7 3a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1zM4 7a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1z"
                    fill="#000"
                />
                </g>
            </svg>
            </div>

            {/* Левая кнопка переключения */}
            <div className={s.lesson__subheaderImg} onClick={goToPreviousLesson}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className={s.lesson__subheaderImgSvg}
                style={{ transform: "rotate(180deg)" }}
            >
                <g>
                <path
                    className={s.lesson__subheaderImgPath}
                    d="m22.707 11.293-7-7a1 1 0 0 0-1.414 1.414L19.586 11H2a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z"
                    fill="#000"
                />
                </g>
            </svg>
            </div>

            {/* Правая кнопка переключения */}
            <div className={s.lesson__subheaderImg} onClick={goToNextLesson}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className={s.lesson__subheaderImgSvg}
            >
                <g>
                <path
                    className={s.lesson__subheaderImgPath}
                    d="m22.707 11.293-7-7a1 1 0 0 0-1.414 1.414L19.586 11H2a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z"
                    fill="#000"
                />
                </g>
            </svg>
            </div>

          </div>
        </div>
        {(lessonData.videolink_uz != null) && 
        <iframe
          className={s.lesson__video}
          src={lessonData?.videolink_uz}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
        }

        <div className={s.lesson__section} dangerouslySetInnerHTML={{__html: handleLang(lessonData.text_uz, lessonData.text_ru, lessonData.text_en)}}>
          
        </div>

        

        <div className={s.lesson__sectionMaterials}>
          <p className={s.lesson__sectionTitle}>{t('materials')}</p>
          <div className={s.lesson__files}>
            {
            
              <a
                href={lessonData?.file_uz}
                target="_blank"
                download
                className={s.lesson__file}
              >
                <div className={s.lesson__fileName}>{t('info')}</div>
                <div className={s.lesson__fileInfo}>
                  {/* <p className={s.lesson__fileSize}>1.89 КБ</p> */}
                  <svg viewBox="0 0 24 24" className={s.lesson__fileIcon}>
                    <g>
                      <path
                        className={s.lesson__fileIconPath}
                        d="M21 19H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2zM12 2a1 1 0 0 0-1 1v10.59l-3.29-3.3a1 1 0 0 0-1.42 1.42l5 5a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0-1.42-1.42L13 13.59V3a1 1 0 0 0-1-1z"
                        fill="#666666"
                      />
                    </g>
                  </svg>
                </div>
              </a>
            }

            {/* <button className={s.lesson__fileDownload}>Скачать все</button> */}
          </div>
        </div>
        <div className="two__btns">
          <Link to={`/themes/${kursId}/`} className='register__btn btn__passive'>
              {t('testBack')}
          </Link>
          
          {dataThemes.length > 0 && (
            <Link to={`/test/${kursId}/${id}/${dataThemes.length}/${nextLesson?.id}/`} className='register__btn'>
              {t('test')}
            </Link>
          )}
        </div>
      </section>
    </div>
  );
};

